module.exports = __webpack_public_path__ + "img/Barbados.f6b3006b.png";